import { render, staticRenderFns } from "./DispatchBar.vue?vue&type=template&id=6d452fde&scoped=true&"
import script from "./DispatchBar.vue?vue&type=script&lang=js&"
export * from "./DispatchBar.vue?vue&type=script&lang=js&"
import style0 from "./DispatchBar.vue?vue&type=style&index=0&id=6d452fde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d452fde",
  null
  
)

export default component.exports